module.exports = __webpack_public_path__ + "img/vps3.f6c440a.png";